import { AddOutlined, DeleteOutlined, EditOutlined, SegmentOutlined } from "@mui/icons-material";
import {
    Box,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Stack,
    Typography,
} from "@mui/material";
import useActionDialog from "../../components/ActionDialog";
import { formatCurrency, formatNum } from "../../utils/numbers";
import { useUserInfo } from "../../utils/security";
import { isEmpty } from "lodash";

export const TransactionItems = ({ items, onAdd, onEdit, onDelete, disabled, currencyCode }) => {
    const showDialog = useActionDialog();
    const { userInfo } = useUserInfo();
    return (
        <>
            {isEmpty(items) ? (
                <Typography variant="caption" component="div">
                    Žádné položky
                </Typography>
            ) : (
                <List>
                    {(items || []).map((item, index) => (
                        <ListItem
                            key={`${item.id}-${index}`}
                            dense
                            disableGutters
                            secondaryAction={
                                <Stack gap={1} direction="row">
                                    <IconButton
                                        edge="end"
                                        disabled={disabled}
                                        onClick={() => onEdit?.(item, index)}>
                                        <EditOutlined />
                                    </IconButton>
                                    <IconButton
                                        edge="end"
                                        disabled={disabled}
                                        onClick={() =>
                                            showDialog(
                                                "Smazat položku",
                                                `Chcete odstranit položku ${item.name}?`,
                                                [
                                                    { title: "Storno" },
                                                    {
                                                        title: "Smazat",
                                                        variant: "contained",
                                                        primary: true,
                                                        onClick: () => {
                                                            onDelete?.(index);
                                                        },
                                                    },
                                                ]
                                            )
                                        }>
                                        <DeleteOutlined />
                                    </IconButton>
                                </Stack>
                            }>
                            <ListItemText
                                primary={item.name}
                                secondary={`${formatNum(
                                    item.units,
                                    2,
                                    userInfo.decimalDelimiter,
                                    userInfo.thousandDelimiter
                                )} ${item.uom}\u00D7${formatCurrency(
                                    item.unitPrice,
                                    currencyCode,
                                    userInfo.currencies,
                                    2,
                                    userInfo.decimalDelimiter,
                                    userInfo.thousandDelimiter
                                )} \u2022 ${formatCurrency(
                                    item.total,
                                    currencyCode,
                                    userInfo.currencies,
                                    2,
                                    userInfo.decimalDelimiter,
                                    userInfo.thousandDelimiter
                                )}`}
                            />
                        </ListItem>
                    ))}
                </List>
            )}
            <Button
                onClick={() => {
                    onAdd?.();
                }}
                disabled={disabled}
                startIcon={<AddOutlined />}
                size="small">
                Přidat položku
            </Button>
        </>
    );
};
